import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Search, Globe, Check } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

// Complete list of countries with their currency
const COUNTRIES = [
  { code: "CA", name: "Canada", currency: "CAD", flag: "🇨🇦" },
  { code: "US", name: "États-Unis", currency: "USD", flag: "🇺🇸" },
  { code: "FR", name: "France", currency: "EUR", flag: "🇫🇷" },
  { code: "BE", name: "Belgique", currency: "EUR", flag: "🇧🇪" },
  { code: "CH", name: "Suisse", currency: "CHF", flag: "🇨🇭" },
  { code: "GB", name: "Royaume-Uni", currency: "GBP", flag: "🇬🇧" },
  { code: "DE", name: "Allemagne", currency: "EUR", flag: "🇩🇪" },
  { code: "IT", name: "Italie", currency: "EUR", flag: "🇮🇹" },
  { code: "ES", name: "Espagne", currency: "EUR", flag: "🇪🇸" },
  { code: "PT", name: "Portugal", currency: "EUR", flag: "🇵🇹" },
  { code: "NL", name: "Pays-Bas", currency: "EUR", flag: "🇳🇱" },
  { code: "AT", name: "Autriche", currency: "EUR", flag: "🇦🇹" },
  { code: "IE", name: "Irlande", currency: "EUR", flag: "🇮🇪" },
  { code: "LU", name: "Luxembourg", currency: "EUR", flag: "🇱🇺" },
  { code: "MC", name: "Monaco", currency: "EUR", flag: "🇲🇨" },
  { code: "MA", name: "Maroc", currency: "MAD", flag: "🇲🇦" },
  { code: "TN", name: "Tunisie", currency: "TND", flag: "🇹🇳" },
  { code: "DZ", name: "Algérie", currency: "DZD", flag: "🇩🇿" },
  { code: "SN", name: "Sénégal", currency: "XOF", flag: "🇸🇳" },
  { code: "CI", name: "Côte d'Ivoire", currency: "XOF", flag: "🇨🇮" },
  { code: "CM", name: "Cameroun", currency: "XAF", flag: "🇨🇲" },
  { code: "MX", name: "Mexique", currency: "MXN", flag: "🇲🇽" },
  { code: "BR", name: "Brésil", currency: "BRL", flag: "🇧🇷" },
  { code: "AR", name: "Argentine", currency: "ARS", flag: "🇦🇷" },
  { code: "CL", name: "Chili", currency: "CLP", flag: "🇨🇱" },
  { code: "CO", name: "Colombie", currency: "COP", flag: "🇨🇴" },
  { code: "PE", name: "Pérou", currency: "PEN", flag: "🇵🇪" },
  { code: "AU", name: "Australie", currency: "AUD", flag: "🇦🇺" },
  { code: "NZ", name: "Nouvelle-Zélande", currency: "NZD", flag: "🇳🇿" },
  { code: "JP", name: "Japon", currency: "JPY", flag: "🇯🇵" },
  { code: "CN", name: "Chine", currency: "CNY", flag: "🇨🇳" },
  { code: "IN", name: "Inde", currency: "INR", flag: "🇮🇳" },
  { code: "KR", name: "Corée du Sud", currency: "KRW", flag: "🇰🇷" },
  { code: "SG", name: "Singapour", currency: "SGD", flag: "🇸🇬" },
  { code: "HK", name: "Hong Kong", currency: "HKD", flag: "🇭🇰" },
  { code: "AE", name: "Émirats arabes unis", currency: "AED", flag: "🇦🇪" },
  { code: "SA", name: "Arabie Saoudite", currency: "SAR", flag: "🇸🇦" },
  { code: "IL", name: "Israël", currency: "ILS", flag: "🇮🇱" },
  { code: "TR", name: "Turquie", currency: "TRY", flag: "🇹🇷" },
  { code: "RU", name: "Russie", currency: "RUB", flag: "🇷🇺" },
  { code: "PL", name: "Pologne", currency: "PLN", flag: "🇵🇱" },
  { code: "CZ", name: "République tchèque", currency: "CZK", flag: "🇨🇿" },
  { code: "HU", name: "Hongrie", currency: "HUF", flag: "🇭🇺" },
  { code: "RO", name: "Roumanie", currency: "RON", flag: "🇷🇴" },
  { code: "GR", name: "Grèce", currency: "EUR", flag: "🇬🇷" },
  { code: "SE", name: "Suède", currency: "SEK", flag: "🇸🇪" },
  { code: "NO", name: "Norvège", currency: "NOK", flag: "🇳🇴" },
  { code: "DK", name: "Danemark", currency: "DKK", flag: "🇩🇰" },
  { code: "FI", name: "Finlande", currency: "EUR", flag: "🇫🇮" },
  { code: "ZA", name: "Afrique du Sud", currency: "ZAR", flag: "🇿🇦" },
  { code: "EG", name: "Égypte", currency: "EGP", flag: "🇪🇬" },
  { code: "NG", name: "Nigeria", currency: "NGN", flag: "🇳🇬" },
  { code: "KE", name: "Kenya", currency: "KES", flag: "🇰🇪" },
  { code: "GH", name: "Ghana", currency: "GHS", flag: "🇬🇭" },
  { code: "PH", name: "Philippines", currency: "PHP", flag: "🇵🇭" },
  { code: "VN", name: "Vietnam", currency: "VND", flag: "🇻🇳" },
  { code: "TH", name: "Thaïlande", currency: "THB", flag: "🇹🇭" },
  { code: "MY", name: "Malaisie", currency: "MYR", flag: "🇲🇾" },
  { code: "ID", name: "Indonésie", currency: "IDR", flag: "🇮🇩" },
  { code: "PK", name: "Pakistan", currency: "PKR", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", currency: "BDT", flag: "🇧🇩" },
  { code: "LK", name: "Sri Lanka", currency: "LKR", flag: "🇱🇰" },
  { code: "HT", name: "Haïti", currency: "HTG", flag: "🇭🇹" },
  { code: "DO", name: "République dominicaine", currency: "DOP", flag: "🇩🇴" },
  { code: "JM", name: "Jamaïque", currency: "JMD", flag: "🇯🇲" },
  { code: "CU", name: "Cuba", currency: "CUP", flag: "🇨🇺" },
  { code: "PR", name: "Porto Rico", currency: "USD", flag: "🇵🇷" },
  { code: "CR", name: "Costa Rica", currency: "CRC", flag: "🇨🇷" },
  { code: "PA", name: "Panama", currency: "PAB", flag: "🇵🇦" },
  { code: "EC", name: "Équateur", currency: "USD", flag: "🇪🇨" },
  { code: "VE", name: "Venezuela", currency: "VES", flag: "🇻🇪" },
  { code: "UY", name: "Uruguay", currency: "UYU", flag: "🇺🇾" },
  { code: "BO", name: "Bolivie", currency: "BOB", flag: "🇧🇴" },
  { code: "PY", name: "Paraguay", currency: "PYG", flag: "🇵🇾" },
];

// Currency categories
const CURRENCY_CATEGORIES = [
  { value: "CAD", label: "Dollar Canadien (CAD)", symbol: "$" },
  { value: "USD", label: "Dollar Américain (USD)", symbol: "$" },
  { value: "EUR", label: "Euro (EUR)", symbol: "€" },
  { value: "OTHER", label: "Autres devises", symbol: "" },
];

// Get country by geolocation - removed

const CountrySelector = ({ value, onChange, onCurrencyChange, error }) => {
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [currencyCategory, setCurrencyCategory] = useState("");
  const dropdownRef = useRef(null);

  // Filter countries based on search
  const filteredCountries = COUNTRIES.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Initialize selected country from value
  useEffect(() => {
    if (value && !selectedCountry) {
      const country = COUNTRIES.find(c => c.code === value);
      if (country) {
        setSelectedCountry(country);
        determineCurrencyCategory(country.currency);
      }
    }
  }, [value]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const determineCurrencyCategory = (currency) => {
    if (currency === "CAD") return setCurrencyCategory("CAD");
    if (currency === "USD") return setCurrencyCategory("USD");
    if (currency === "EUR") return setCurrencyCategory("EUR");
    return setCurrencyCategory("OTHER");
  };

  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    setSearchTerm("");
    setIsOpen(false);
    onChange(country.code);
    
    // Determine currency category
    determineCurrencyCategory(country.currency);
    onCurrencyChange(country.currency);
  };

  const handleCurrencyChange = (category) => {
    setCurrencyCategory(category);
    if (category !== "OTHER") {
      onCurrencyChange(category);
    } else if (selectedCountry) {
      onCurrencyChange(selectedCountry.currency);
    }
  };

  return (
    <div className="space-y-4">
      {/* Country Selection */}
      <div className="space-y-2">
        <Label htmlFor="country">{t('auth.countryOfResidence')} *</Label>
        <div className="relative" ref={dropdownRef}>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input
                type="text"
                placeholder={t('auth.searchCountry')}
                value={selectedCountry ? `${selectedCountry.flag} ${selectedCountry.name}` : searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  if (selectedCountry) {
                    setSelectedCountry(null);
                    onChange(""); // Clear the country value when user starts typing
                  }
                  setIsOpen(true);
                }}
                onFocus={() => {
                  setIsOpen(true);
                  if (selectedCountry) {
                    setSearchTerm(selectedCountry.name); // Keep the name for easy re-search
                  }
                }}
                className={`pl-10 ${error ? 'border-red-500' : ''}`}
                data-testid="country-search"
              />
            </div>
            
            {isOpen && (
              <div className="absolute z-50 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
                {filteredCountries.length === 0 ? (
                  <div className="p-3 text-center text-gray-500">
                    Aucun pays trouvé
                  </div>
                ) : (
                  filteredCountries.map((country) => (
                    <button
                      key={country.code}
                      type="button"
                      className="w-full px-3 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
                      onClick={() => handleSelectCountry(country)}
                      data-testid={`country-option-${country.code}`}
                    >
                      <span className="text-xl">{country.flag}</span>
                      <span className="flex-1">{country.name}</span>
                      <span className="text-xs text-gray-500">{country.currency}</span>
                      {selectedCountry?.code === country.code && (
                        <Check className="h-4 w-4 text-green-500" />
                      )}
                    </button>
                  ))
                )}
              </div>
            )}
          </div>
        {error && <p className="text-xs text-red-500">{error}</p>}
      </div>

      {/* Currency Info (Read-only) */}
      {selectedCountry && (
        <div className="space-y-2">
          <Label>Devise de paiement</Label>
          <div className="flex items-center gap-2 p-3 bg-brand-50 border border-brand-200 rounded-md">
            <Globe className="h-5 w-5 text-brand-600" />
            <div className="flex-1">
              <span className="font-medium text-gray-900">
                {selectedCountry.currency === "CAD" && "Dollar Canadien (CAD)"}
                {selectedCountry.currency === "USD" && "Dollar Américain (USD)"}
                {selectedCountry.currency === "EUR" && "Euro (EUR)"}
                {!["CAD", "USD", "EUR"].includes(selectedCountry.currency) && `${selectedCountry.currency}`}
              </span>
              <p className="text-sm text-gray-600 mt-1">
                {selectedCountry.code === "CA" ? (
                  "Paiement par Virement Interac si les deux parties sont en CAD, sinon par Wise dans la devise du vendeur"
                ) : (
                  "Paiement par Wise dans la devise du vendeur"
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
export { COUNTRIES, CURRENCY_CATEGORIES };
